<template>
  <b-container>
    <b-row>
      <b-col cols="12" sm="6">
        <b-form-group label="First Name" label-for="firstName">
          <b-form-input
            id="firstName"
            required
            v-model="localValue.firstName"
            type="text"
            :state="state('firstName')"
            aria-describedby="firstName-error"
          />
          <b-form-invalid-feedback id="firstName-error">
            {{ errors.firstName }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="12" sm="6">
        <b-form-group label="Last Name" label-for="lastName">
          <b-form-input
            id="lastName"
            required
            v-model="localValue.lastName"
            type="text"
            :state="state('lastName')"
            aria-describedby="lastName-error"
          />
          <b-form-invalid-feedback id="lastName-error">
            {{ errors.lastName }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" sm="6">
        <b-form-group label="Email" label-for="email">
          <b-form-input
            id="email"
            required
            v-model="localValue.email"
            type="email"
            :state="state('email')"
            aria-describedby="email-error"
          />
          <b-form-invalid-feedback id="email-error">
            {{ errors.email }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="12" sm="6">
        <b-form-group label="Order Number" label-for="orderNumber">
          <b-form-input
            id="orderNumber"
            required
            :readonly="orderNumberReadOnly"
            v-model="localValue.orderNumber"
            type="text"
            :state="state('orderNumber')"
            aria-describedby="orderNumber-error"
          />
          <b-form-invalid-feedback id="orderNumber-error">
            {{ errors.orderNumber }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  props: {
    value: {
      firstName: {
        type: String,
        default: ""
      },
      lastName: {
        type: String,
        default: ""
      },
      email: {
        type: String,
        default: ""
      },
      orderNumber: {
        type: String,
        default: ""
      }
    },
    orderNumberReadOnly: {
      type: Boolean,
      required: false,
      default: false
    },
    errorMessages: {
      type: Object,
      required: false,
      default() {
        return {
          firstName: null,
          lastName: null,
          email: null,
          orderNumber: null
        };
      }
    }
  },
  watch: {
    localValue: {
      handler(newVal) {
        this.$emit("input", newVal);
      },
      deep: true
    }
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      }
    },
    errors() {
      return {
        firstName: this.getErrorMessage("firstName"),
        lastName: this.getErrorMessage("lastName"),
        email: this.getErrorMessage("email"),
        orderNumber: this.getErrorMessage("orderNumber")
      };
    }
  },
  methods: {
    getErrorMessage(name) {
      return !!this.errorMessages ? this.errorMessages[name] : null;
    },
    state(name) {
      return this.errors[name] == null ? null : !this.errors[name].length;
    }
  }
};
</script>
